import Choices from 'choices.js';
import './form-input.scss';

class FormInput {
    constructor (element, options) {
        const settings = {
            activeClassName: 'is--active',
            errorClassName: 'has--error',
            filledClassName: 'is--filled',
            onChoiceChange: null
        };

        this.$element = element;
        this.$input = this.$element.querySelector('input, textarea, select');
        this.fieldTagName = this.$input.tagName.toLowerCase();
        this.settings = Object.assign({}, settings, options);
    }

    initialize () {
        if (this.fieldTagName === 'select') {
            this.buildCustomSelect();
        }
        this.setEvents();
        this.setFilled();
    }

    buildCustomSelect () {
        let multiple = false;
        let searchEnabled = false;

        if (this.$input.getAttribute('multiple') !== null) {
            multiple = true;
            searchEnabled = true;
        }

        const $emptyValue = this.$input.querySelector('option[value=""]');

        if ($emptyValue) {
            $emptyValue.setAttribute('placeholder', '');
        }

        new Choices(this.$input, {  
            itemSelectText: '',
            removeItemButton: multiple,
            renderSelectedChoices: 'always',
            searchEnabled: searchEnabled,
            shouldSort: false,
            placeholder: true
        });
    }

    setEvents () {
        if (this.$input) {
            if (this.fieldTagName !== 'select') {
                this.$input.addEventListener('keyup', () => {
                    this.setFilled();
                    this.removeError();
                });

                this.$input.addEventListener('focus', () => {
                    this.setFilled();
                    this.setFocus(true);
                });

                this.$input.addEventListener('blur', () => {
                    this.setFocus(false);
                });

                this.$input.addEventListener('change', () => {
                    this.setFilled();
                });
            } else {
                this.$input.addEventListener('choice', (event) => {
                    this.removeError();
                    if (event.detail.choice.placeholder === false) {
                        this.$element.classList.add(this.settings.filledClassName);
                    } else {
                        this.$element.classList.remove(this.settings.filledClassName);
                    }
                });

                this.$input.addEventListener('focus', () => {
                    this.setFocus(true);
                });

                this.$input.addEventListener('showDropdown', () => {
                    this.setFocus(true);
                });

                this.$input.addEventListener('hideDropdown', () => {
                    this.setFocus(false);
                });
            }
        }
    }

    removeError () {
        if (this.$element.classList.contains(this.settings.errorClassName)) {
            this.$element.classList.remove(this.settings.errorClassName);
        }
    }

    setFocus (state) {
        if (state === true) {
            this.$element.classList.add(this.settings.activeClassName);
        } else {
            this.$element.classList.remove(this.settings.activeClassName);
        }
    }

    setFilled () {
        const checkFilled = ($field) => {
            let fieldFilled = false;
            switch (this.fieldTagName) {
            case 'select':
                if ($field.selectedIndex !== -1) {
                    const selectedOption = $field.options[$field.selectedIndex];
                    if (selectedOption.getAttribute('value') !== null && selectedOption.getAttribute('value') !== $field.getAttribute('placeholder')) {
                        fieldFilled = true;
                    }
                }
                break;

            default:
                if ($field.value !== '') {
                    fieldFilled = true;
                }
                break;
            }

            return fieldFilled;
        };

        if (checkFilled(this.$input) === true) {
            this.$element.classList.add(this.settings.filledClassName);
        } else {
            this.$element.classList.remove(this.settings.filledClassName);
        }
    }
}

export { FormInput };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $$roots = $context.querySelectorAll('[data-form="input"]');
        $$roots.forEach($root => {
            const $rootAPI = new FormInput($root);
            $rootAPI.initialize();
        });
    }
});
